module.exports = __webpack_public_path__ + "static/media/Madfit-14.b08499a5.jpg";